import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const CarlaApp = () => {

  const history = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      window.location.href = 'https://www.instagram.com/p/Cr6i6yMMkLTZw4LiUTOKZ9HetfLhCBWCUEvYu80/';
    }, 0);

    return () => clearTimeout(redirectTimeout);
  }, [history]);

  return (<></>);
}
